import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { CompletionStatuses } from '../../../constants';
import { useTracker } from '../../../context/hooks';
import { SeoRecommendations } from '../../constants';
import { ImageList } from '../../sharedComponents/ImageList';
import { RecommendationBaseView } from '../../sharedComponents/RecommendationBaseView';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const VerifyEmptyImageAltTextView = ({
  auditResult,
  editorApi
}) => {
  const {
    track
  } = useTracker();
  const {
    status,
    imagesWithEmptyAltText
  } = auditResult;
  const isIncomplete = status === CompletionStatuses.INCOMPLETE && imagesWithEmptyAltText;
  const handleTrackAction = () => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedFixLink',
      recommendationType: SeoRecommendations.VERIFY_EMPTY_IMAGE_ALT_TEXT
    });
  };
  const handleClickDecorativeImagesKBLink = event => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedLearnMoreLink',
      recommendationType: SeoRecommendations.VERIFY_EMPTY_IMAGE_ALT_TEXT,
      linkAddress: event.currentTarget.href
    });
  };
  const handleClickGeneralInfoKBLink = event => {
    track('Xray Panel', 'Xray Interaction', {
      action: 'clickedLearnMoreLink',
      recommendationType: SeoRecommendations.VERIFY_EMPTY_IMAGE_ALT_TEXT,
      linkAddress: event.currentTarget.href
    });
  };
  return /*#__PURE__*/_jsxs(RecommendationBaseView, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "xray-recommendation-lib.seo.recommendations.title.VERIFY_EMPTY_IMAGE_ALT_TEXT"
    }),
    description: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "xray-recommendation-lib.seo.recommendations.description.VERIFY_EMPTY_IMAGE_ALT_TEXT",
      options: {
        link: /*#__PURE__*/_jsx(Link, {
          href: "https://www.w3.org/WAI/tutorials/images/decorative/",
          external: true,
          onClick: handleClickDecorativeImagesKBLink,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "xray-recommendation-lib.seo.recommendations.linkText.VERIFY_EMPTY_IMAGE_ALT_TEXT_DECORATIVE_IMAGES"
          })
        })
      }
    }),
    status: status,
    children: [isIncomplete && /*#__PURE__*/_jsx(ImageList, {
      images: imagesWithEmptyAltText,
      subHeader: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.recommendations.subHeader.VERIFY_EMPTY_IMAGE_ALT_TEXT"
      }),
      action: editorApi.openImageModule,
      onTrackAction: handleTrackAction
    }), /*#__PURE__*/_jsx(View, {
      marginInlineStart: "600",
      marginBlockStart: "400",
      marginBlockEnd: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(Link, {
        href: "https://knowledge.hubspot.com/seo/understand-seo-recommendations#add-image-alt-text-attribute",
        external: true,
        onClick: handleClickGeneralInfoKBLink,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "xray-recommendation-lib.seo.recommendations.linkText.VERIFY_EMPTY_IMAGE_ALT_TEXT_GENERAL_INFO"
        })
      })
    })]
  });
};